import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ApplicationsService } from '../services/applications.service';

import { ApplicationsStateModel } from '../interfaces/applications-state.interface';
import {
    DeleteApplication,
    SetGridState,
    SetInfiniteInitialRowCount,
    SetQuickFilterValue
} from './applications.actions';
import { GridState } from 'ag-grid-community';

const defaults: ApplicationsStateModel = {
    quickFilterValue: null
};

@State<ApplicationsStateModel>({
    name: 'managementApplications',
    defaults
})
@Injectable()
export class ApplicationsState {
    private readonly applicationsService = inject(ApplicationsService);

    @Selector()
    static gridState(state: ApplicationsStateModel): GridState | undefined {
        return state.gridState;
    }

    @Selector()
    static infiniteInitialRowCount(state: ApplicationsStateModel): number | undefined {
        return state.infiniteInitialRowCount;
    }

    @Selector()
    static quickFilterValue(state: ApplicationsStateModel): string | null {
        return state.quickFilterValue;
    }

    @Action(SetGridState)
    setGridState(ctx: StateContext<ApplicationsStateModel>, { gridState }: SetGridState): void {
        ctx.patchState({ gridState });
    }

    @Action(SetInfiniteInitialRowCount)
    setInfiniteInitialRowCount(
        ctx: StateContext<ApplicationsStateModel>,
        { infiniteInitialRowCount }: SetInfiniteInitialRowCount
    ): void {
        ctx.patchState({ infiniteInitialRowCount });
    }

    @Action(SetQuickFilterValue)
    setQuickFilterValue(ctx: StateContext<ApplicationsStateModel>, { quickFilterValue }: SetQuickFilterValue): void {
        ctx.patchState({ quickFilterValue });
    }

    @Action(DeleteApplication)
    public deleteApplication(
        _ctx: StateContext<ApplicationsStateModel>,
        { applicationId }: DeleteApplication
    ): Observable<void> {
        return this.applicationsService.deleteApplication(applicationId);
    }
}
